import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {GoriSignatureUploadPhoto} from '../../modules/gori-signature'

export default function GoriSignatureUploadPhotoWrapper() {
  return (
    <PublicWrapper>
      <GoriSignatureUploadPhoto />
    </PublicWrapper>
  )
}
